import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import { Table, Button, Form } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "../../../data/applicationSlice"
import { css } from "@emotion/react"
import { getLimits, getRetentionAmount } from "../../../data/enumSlice"
import { byPrefixAndName } from "@awesome.me/kit-de80aecb6a/icons"

const componentStyle = css`
    .option {
        width: 52px;
        text-align: right;
    }
`

const { updateApplicationData } = actions

const DesiredLimits = ({ applicationData, validationError, setValidationErrors }) => {
    const dispatch = useDispatch()
    const [limitsData, setLimitsData] = useState([
        {
            limits: undefined,
            retention: undefined,
            id: "00000000-0000-0000-0000-000000000000",
            applicationId: "00000000-0000-0000-0000-000000000000",
            name: "OPTION 1"
        }
    ])
    const { retentionAmounts, limits } = useSelector((state) => state.enums)

    useEffect(() => {
        !retentionAmounts?.length && dispatch(getRetentionAmount())
        !limits?.length && dispatch(getLimits())
    }, [])

    const handleAddRow = () => {
        if (limitsData.length < 4) {
            setLimitsData([
                ...limitsData,
                {
                    id: "00000000-0000-0000-0000-000000000000",
                    applicationId: "00000000-0000-0000-0000-000000000000",
                    limits: undefined,
                    retention: undefined,
                    name: `OPTION ${limitsData?.length + 1}`
                }
            ])
        }
    }

    const handleDeleteRow = (index) => {
        const newData = JSON.parse(JSON.stringify(limitsData))
        newData.splice(index, 1)
        setLimitsData(
            newData?.map((data, i) => ({
                ...data,
                name: `OPTION ${i + 1}`
            }))
        )
    }

    const handleInputChange = (index, field, value) => {
        const newData = [...limitsData]
        const updatedData = { ...newData[index] }
        updatedData[field] = value
        newData[index] = updatedData
        setLimitsData(newData)

        if (validationError) {
            const newError = { ...validationError }
            delete newError[field + "-" + index]
            setValidationErrors(newError)
        }
    }

    useEffect(() => {
        dispatch(updateApplicationData({ field: "limitsAndRetentions", value: limitsData }))
    }, [limitsData])

    useEffect(() => {
        if (applicationData?.limitsAndRetentions) {
            setLimitsData(applicationData.limitsAndRetentions)
        }
    }, [applicationData])

    return (
        <div css={componentStyle}>
            <div className="d-flex justify-content-between align-items-center my-2">
                <h6>1. Desired Limits of Liability and Retention Amount:</h6>
                {limitsData?.length < 4 && (
                    <Button
                        className="btn-sm"
                        variant="primary"
                        onClick={handleAddRow}>
                        Add
                    </Button>
                )}
            </div>
            <Table
                striped
                bordered
                hover
                responsive>
                <thead>
                    <tr>
                        <th className="option">Option</th>
                        <th>Each Loss / Aggregate Limit ($)</th>
                        <th>Retention Amount($)</th>
                        <th style={{ width: "80px" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {limitsData?.map((data, index) => (
                        <tr key={index}>
                            <td className="option">{index + 1}</td>
                            <td>
                                <Form.Select
                                    name="limits"
                                    className={`form-select-sm ${validationError?.["limits-" + index] ? "error" : ""}`}
                                    value={data.limits || ""}
                                    onChange={(e) => handleInputChange(index, "limits", e.target.value)}>
                                    <option value="">--- Select ---</option>
                                    {limits?.map((limit) => (
                                        <option
                                            key={limit?.value}
                                            value={limit?.value}>
                                            {limit?.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </td>

                            <td className="retention-amount">
                                <Form.Select
                                    className={`form-select-sm ${
                                        validationError?.["retention-" + index] ? "error" : ""
                                    }`}
                                    name="retention"
                                    value={data.retention || ""}
                                    onChange={(e) => handleInputChange(index, "retention", e.target.value)}>
                                    <option value="">--- Select ---</option>
                                    {retentionAmounts?.map((retentionAmount) => (
                                        <option
                                            key={retentionAmount?.value}
                                            value={retentionAmount?.value}>
                                            {retentionAmount?.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </td>
                            <td className="align-text-center">
                                {limitsData?.length > 1 && (
                                    <FontAwesomeIcon
                                        icon={byPrefixAndName.fal["trash"]}
                                        className="clickable-icon icon-red"
                                        onClick={() => handleDeleteRow(index)}
                                    />
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    )
}

export default DesiredLimits
